import { RootState } from '../../store/store';
import { GAME_POPUP_KEY, InGamePopupState } from './inGameSlice';
import { POPUP_KEY, PopupState } from './slice';

export const getPopupState = (state: RootState) =>
    state[POPUP_KEY] as PopupState;
export const getInGamePopupSate = (state: RootState) =>
    state[GAME_POPUP_KEY] as InGamePopupState;
